import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { i18n } from "../../translate/i18n";

// Numero do contato + chip "Fixo" quando o numero e telefone fixo (nao recebe
// SMS). Fica dentro da mesma celula (sem coluna nova): o numero encolhe com
// reticencias e o chip nunca encolhe nem quebra linha.
// `classes` vem do pai (que chama o hook de estilos uma vez so): evita uma
// folha JSS dinamica por linha da tabela.
const NumeroComTipo = ({ number, numberType, classes }) => {
  const fixo = numberType === "landline";
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
      <span
        style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}
      >
        {number}
      </span>
      {fixo && (
        <Tooltip title={i18n.t("contactListItems.numberType.landlineHint")}>
          <span
            tabIndex={0}
            aria-label={i18n.t("contactListItems.numberType.landlineHint")}
            className={`${classes.statusPill} ${classes.toneNeutral}`}
            style={{ flexShrink: 0 }}
          >
            {i18n.t("contactListItems.numberType.landline")}
          </span>
        </Tooltip>
      )}
    </span>
  );
};

export default NumeroComTipo;
